// sort by alphabet
import type { GridColumn, GridRow } from '@omnia/ui/src/lib'
import { lazy } from 'react'
import { GridAccordion } from '@/features/grid/accordion/GridAccordion'
import { GridBannerTextImageAction } from '@/features/grid/bannerTextImageAction/GridBannerTextImageAction'
import { Button } from '@/features/grid/button/Button'
import { Headline } from '@/features/grid/headline/Headline'
import { Media } from '@/features/grid/media/Media'
import { MiniPromo } from '@/features/grid/miniPromo/MiniPromo'
import { GridRichText } from '@/features/grid/richText/RichText'
import { VideoEmbed } from '@/features/grid/videoEmbed/VideoEmbed'
import { BannerImage } from './bannerImage/BannerImage'
import { GridCardGrid } from './cardGrid/GridCardGrid'
import { GalleryImageAndText } from './galleryImageAndText/GalleryImageAndText'
import type { GridCommonSettingsPropsApi } from './gridCommonSettings.models'
import { TextBoxes } from './textBoxes/TextBoxes'
import { TwoButtons } from './twoButtons/TwoButtons'

// Lazy load some large grid components
const CardsCarousel = lazy(() => import('@/features/grid/carousel/CardsCarousel'))
const CarouselImageTextActions = lazy(() => import('@/features/grid/carouselImageTextActions/CarouselImageTextActions'))
const CarouselQuotes = lazy(() => import('@/features/grid/carouselQuotes/CarouselQuotes'))
const UmbracoForm = lazy(() => import('@/features/grid/umbracoForm/UmbracoForm'))
const FilmList = lazy(() => import('@/features/grid/filmList/FilmList'))
const MemberAlready = lazy(() => import('@/features/grid/memberAlready/MemberAlready'))
const NewsletterBox = lazy(() => import('@/features/grid/newsletterBox/NewsletterBox'))
const DottedDivider = lazy(() => import('@/features/grid/dottedDivider/DottedDivider'))

export type CurzonGridRow = GridRow<GridCommonSettingsPropsApi, GridCommonSettingsPropsApi>
export type CurzonGridColumn = GridColumn<GridCommonSettingsPropsApi>

export const GridTypes = {
    gridHeadline: Headline,
    gridImage: Media,
    gridRichText: GridRichText,
    gridAccordion: GridAccordion,
    gridButton: Button,
    gridFilmList: FilmList,
    gridGalleryImageAndText: GalleryImageAndText,
    gridTextBox: TextBoxes,
    gridCarouselQuotes: CarouselQuotes,
    gridBannerImage: BannerImage,
    gridCarouseImageTextActions: CarouselImageTextActions,
    gridBannerTextImageAction: GridBannerTextImageAction,
    gridCarousel: CardsCarousel,
    gridUmbracoForm: UmbracoForm,
    gridCardGrid: GridCardGrid,
    gridVideoEmbed: VideoEmbed,
    gridBannerMiniPromo: MiniPromo,
    gridNewsletterBox: NewsletterBox,
    gridMemberAlready: MemberAlready,
    gridDottedDivider: DottedDivider,
    gridTwoButtons: TwoButtons,
}
